import React, { Component } from 'react';
import Typed from 'typed.js';
import differenceWith from 'lodash/differenceWith';
import isEqual from 'lodash/isEqual';

class DynamicText extends Component {
    rootElement = React.createRef();

    componentDidMount() {
        const { items, typedOptions } = this.props;

        let TextWrapper = this.rootElement.current.previousSibling;
        if (items?.length) {
            items.forEach((item) => {
                let Text = document.createElement('span');
                Text.classList.add(item.id);
                Text.setAttribute('data-testid', 'dynamic-text');
                Text.innerHTML = item.content;
                TextWrapper.appendChild(Text);
                return;
            });
        }

        this.constructTyped(TextWrapper, typedOptions);
    }

    constructTyped(stringsElement, options = {}) {
        if (this.typed) {
            this.typed.destroy();
        }
        const prevOptions = this.props.typedOptions;

        this.typed = new Typed(
            this.rootElement.current,
            Object.assign({ stringsElement }, prevOptions, options)
        );
    }

    shouldComponentUpdate(nextProps) {
        if (this.props !== nextProps) {
            let TextWrapper = this.rootElement.current.previousSibling;

            const addAble = differenceWith(
                nextProps.items,
                this.props.items,
                isEqual
            );
            const removAble = differenceWith(
                this.props.items,
                nextProps.items,
                isEqual
            );

            const options = differenceWith(
                [nextProps.typedOptions],
                [this.props.typedOptions],
                isEqual
            );

            if (addAble.length && !removAble.length) {
                let Text = document.createElement('span');
                Text.classList.add(addAble[0].id);
                Text.innerText = addAble[0].content;
                TextWrapper.appendChild(Text);
            }

            [...TextWrapper.children].forEach((Text) => {
                if (addAble.length && removAble.length) {
                    let exist = Text.classList.contains(addAble[0].id);

                    if (exist) {
                        Text.innerHTML = addAble[0].content;
                    }
                }
                if (!addAble.length && removAble.length) {
                    let removAbleItem = Text.classList.contains(
                        removAble[0].id
                    );
                    removAbleItem && Text.remove();
                }
            });

            if (removAble.length || addAble.length || options.length) {
                this.constructTyped(TextWrapper, options[0]);
            }
            return true;
        }
        return false;
    }

    render() {
        return (
            <span
                className="dorik-heading__dynamic"
                data-testid="dynamic-text-wrapper"
            >
                <div></div>
                <span ref={this.rootElement} />
            </span>
        );
    }
}

export default DynamicText;
